<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-shopping-cart"
    :showFooter="false"
    :scrollable="true"
  >
    <div>
      <Spinner v-if="loading" />
      <div class="text-center text-danger" v-if="loadingError">{{loadingError}}</div>

      <TabbedBox v-if="order">
         <template v-slot:tablist>
          <Tab :first="true" tabid="tab-production">
            <i class="far fa-tools"></i> Production
          </Tab>
          <Tab tabid="tab-details">
            <i class="far fa-clipboard-list-check"></i> Details
          </Tab>
        </template>

        <template v-slot:tabcontent>
          <TabPage :first="true" tabid="tab-production">
            <OrderProductionPreview
              :order="order"
              :compactMode="true"
              :showPopoverButtons="false"
            />
          </TabPage>
          <TabPage tabid="tab-details">
            <FormGroup>
              <FormRow label="Order Number"><FormStaticLabel>#{{order.sequenceNumber}}</FormStaticLabel></FormRow>
              <FormRow label="Customer"><FormStaticLabel>{{order.contact.name}}</FormStaticLabel></FormRow>
              <FormRow label="Customer Ref"><FormStaticLabel>{{order.customerRef}}</FormStaticLabel></FormRow>
              <FormRow label="Estimated Due Date"><FormStaticLabel>{{order.dateCurrentlyDue | formatDateTime}}</FormStaticLabel></FormRow>
              <FormRow label="Dispatch Type"><FormStaticLabel>{{order.despatchTaskType.name}}</FormStaticLabel></FormRow>
            </FormGroup>
                  
          </TabPage>
        </template>
      </TabbedBox>
      

    </div>
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import OrderProductionPreview from '@/modules/orders/components/orderProductionPreview'

export default {
  name: 'OrderPreviewDialog',
  mixins: [
    modalDialog
  ],
  components: {
    ModalDialog,
    OrderProductionPreview
  },
  props: {
    orderId: Number,
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      order: null,
    }
  },
  computed: {
    title() {
      if(this.order)
        return `Order #${this.order.sequenceNumber}`
      return 'Order'
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
    show(params) {
      this.requestData()

      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.ordersService.getOrder(this.orderId)
      .then(response => {
        this.order = response.data

      })
      .catch(err => {
        this.loadingError = 'Error loading order'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>